export default "__VITE_ASSET__CnS$DwAa__"